import { useState } from 'react';
import { Pencil, Check, X, Trash2 } from 'lucide-react';
import axios from 'axios';
import UserAvatar from '../UserAvatar';
import ProfilePopover from '../ProfilePopover';

const ChildCommentItem = ({
  setComments,
  me,
  clientId,
  boardType,
  childComment,
  setCommentUpdate,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editContent, setEditContent] = useState(childComment.content);

  const authorName = childComment.client?.nickName || childComment.client?.name;
  const isMyComment = clientId === Number(childComment.clientId) || me?.adminYn === 'Y';

  const handleEdit = () => {
    if (!editContent.trim()) return;
    axios
      .put(`/board/comment/modify/${childComment.id}`, { content: editContent, boardType }, { withCredentials: true })
      .then(() => {
        setCommentUpdate((prev) => !prev);
        setIsEditing(false);
      })
      .catch(() => {
        alert('댓글 수정 중 오류가 발생했습니다.');
      });
  };

  const handleDelete = () => {
    if (!window.confirm('댓글을 삭제하시겠습니까?')) return;
    axios
      .delete(`/board/comment/${childComment.id}?boardType=${boardType}`, { withCredentials: true })
      .then(() => {
        setComments((prev) => prev.filter((c) => c.id !== childComment.id));
      })
      .catch(() => {
        alert('댓글 삭제 중 오류가 발생했습니다.');
      });
  };

  return (
    <div className="flex items-start gap-2">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <ProfilePopover user={{
            userType: 'client',
            userId: childComment.client?.id,
            name: authorName,
            profileImage: childComment.client?.profileImage,
            adminYn: childComment.client?.adminYn,
          }}>
            <UserAvatar
              name={authorName}
              profileImage={childComment.client?.profileImage}
              userType="client"
              adminYn={childComment.client?.adminYn}
              size={20}
            />
            <span className="text-xs font-semibold text-slate-300 hover:text-sky-400 transition-colors">
              {authorName}
            </span>
          </ProfilePopover>
          <span className="text-[11px] text-slate-600">
            {new Date(childComment.createdAt).toLocaleDateString('ko-KR')}
          </span>
        </div>
        {isEditing ? (
          <div className="flex items-center gap-2 mt-1">
            <input
              className="flex-1 px-3 py-1 rounded-lg border border-white/[0.08] text-sm outline-none focus:ring-2 focus:ring-sky-500/30 focus:border-transparent bg-[#1a2b42] text-slate-200"
              value={editContent}
              onChange={(e) => setEditContent(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleEdit()}
              autoFocus
            />
            <button
              className="p-1 text-sky-400 hover:text-sky-300 transition-colors"
              onClick={handleEdit}
              title="완료">
              <Check size={13} />
            </button>
            <button
              className="p-1 text-slate-500 hover:text-slate-300 transition-colors"
              onClick={() => { setIsEditing(false); setEditContent(childComment.content); }}
              title="취소">
              <X size={13} />
            </button>
          </div>
        ) : (
          <p className="text-sm text-slate-400 mt-0.5 whitespace-pre-wrap">{childComment.content}</p>
        )}
      </div>
      {isMyComment && !isEditing && (
        <div className="flex items-center gap-0.5 shrink-0">
          <button
            className="p-1 text-slate-600 hover:text-sky-400 transition-colors"
            onClick={() => setIsEditing(true)}
            title="수정">
            <Pencil size={12} />
          </button>
          <button
            className="p-1 text-slate-600 hover:text-rose-400 transition-colors"
            onClick={handleDelete}
            title="삭제">
            <Trash2 size={12} />
          </button>
        </div>
      )}
    </div>
  );
};

export default ChildCommentItem;
